const Expose = function() {
    if (parallax.pageName !== 'expose') return;

    const canvas = document.querySelector('.js-expose-icon');
    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio;

    let progress = 0;
    const duration = 800;
    let startTime = null;

    const width = canvas.offsetWidth;
    const sf = width / 800;

    const circles = [
        {
            r: 73,
            cx: [111 + 308 + 150, 111 + 308],
            cy: [73 + 306 - 150, 73 + 306],
            color: [169, 97, 46], // hsl
        },
        {
            r: 68,
            cx: [68 + 308 - 150, 68 + 308],
            cy: [120 + 306 + 150, 120 + 306],
            color: [262, 65, 61], // hsl
        },
        {
            r: 33,
            cx: [135 + 308 + 150, 135 + 308],
            cy: [153 + 306 + 150, 153 + 306],
            color: [180, 6, 58], // hsl
        },
    ];

    function draw() {
        const now = performance.now();
        if (!startTime) {
            startTime = now;
        }
        progress = (now - startTime) / duration;
        if (progress > 1) {
            progress = 1;
        }

        ctx.clearRect(0, 0, width, width);
        ctx.globalCompositeOperation = 'multiply';

        ctx.save();
        ctx.translate(width/2, width/2);
        const rotation = -270 + (easing(progress) * 270);
        ctx.rotate((Math.PI/180)*rotation);
        ctx.translate(width/-2, width/-2);

        for (let i = 0; i < circles.length; i++) {
            const circle = circles[i];

            const c = lerp([circle.cx[0], circle.cy[0]], [circle.cx[1], circle.cy[1]], progress);

            ctx.beginPath();
            ctx.arc(c[0]*sf, c[1]*sf, circle.r*sf, 0, Math.PI*2, true);
            ctx.fillStyle = `hsla(${circle.color[0]}, ${circle.color[1]}%, ${circle.color[2] * progress}%, ${progress})`;
            ctx.fill();
        }
        ctx.restore();

        if (progress < 1) {
            requestAnimationFrame(draw);
        }
    }

    function easing(t) {
        return (--t) * t * t + 1;
    }

    function lerp(a, b, p) {
        const x = a[0] + (b[0] - a[0]) * easing(p);
        const y = a[1] + (b[1] - a[1]) * easing(p);

        return [x, y];
    }

    return {
        init: function() {
            canvas.width = width * pixelRatio;
            canvas.height = width * pixelRatio;
            ctx.scale(pixelRatio, pixelRatio);

            requestAnimationFrame(draw);
        },
    };
};

export default Expose;




// WEBPACK FOOTER //
// ./assets/js/components/_expose.js